import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=565f00b4&scoped=true&"
import script from "./TermsOfService.vue?vue&type=script&lang=js&"
export * from "./TermsOfService.vue?vue&type=script&lang=js&"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=565f00b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f00b4",
  null
  
)

export default component.exports